import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "4 3.5 16.5 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "icon/back" }), /* @__PURE__ */ _jsx("g", {
		id: "Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "icon/back",
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.5,5.13603897 L12.2071068,5.84314575 L7.05003897,10.999039 L19,11 L19,12 L7.05003897,11.999039 L12.2071068,17.1568542 L11.5,17.863961 L5.13603897,11.5 L11.5,5.13603897 Z",
				id: "Combined-Shape"
			})
		})
	})]
});
export default SvgBack;
